import { Pill } from "@clipboard-health/ui-components";

interface MissingCredentialRequirementsPillProps {
  type: "BASE_CREDENTIAL" | "WORKPLACE_CREDENTIAL";
}
export function MissingCredentialRequirementsPill(props: MissingCredentialRequirementsPillProps) {
  const { type } = props;
  return (
    <Pill
      size="small"
      variant="outlined"
      label={type === "BASE_CREDENTIAL" ? "State qual. missing" : "Qualification missing"}
      iconType="locked-filled"
      backgroundColor={(theme) => theme.palette.background.tertiary}
      outlineColor={(theme) => theme.palette.intent?.neutral.border}
      color={(theme) => theme.palette.intent?.neutral.text}
      iconColor={(theme) => theme.palette.intent?.neutral.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
